export const base_url="https://tipsy-nails.firebaseio.com";
export const dayStart = '08:00';
